module.exports = "/static/Images/pt-br/Seven.png";